export default {
    enable: {
        type: Boolean,
        default: undefined
    },
    onLabel: {
        type: String,
        default: undefined
    },
    offLabel: {
        type: String,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/ObsoleteSwitchProps.js